<div class="lqd-column col-md-4">
  <h3>{{ description.title }}</h3>
  <p class="text">{{ description.text }}</p>
  <div class="mt-4">
    <i antIcon type="clock-circle" class="text-primary" theme="outline"></i>&nbsp;
    <span class="font-weight-bold text-primary">{{ description.duration }}</span>
  </div>
</div>
